import React, { Component } from 'react';

import PropTypes from 'prop-types';

import { fireSplitTestEvent } from 'wanderu-ducks-split-test';
import { getLogger } from 'wanderu-logger';

import SplitTestContext from '../SplitTestContext';
import { calculateDefaultProps } from '../utils';

const logger = getLogger('SplitTestComponent');

function renderControlForVariant(aliases, testVariant) {
    return (testVariant === '-1' || testVariant === 'control')
        || (aliases && !!aliases.length && aliases.includes(testVariant));
}

class SplitTest extends Component {
    static propTypes = {
        calculateProps: PropTypes.func,
        onShowTest: PropTypes.func,
        testName: PropTypes.string.isRequired,
    }

    static defaultProps = {
        calculateProps: calculateDefaultProps,
        onShowTest() {},
    }

    constructor(props) {
        super(props);

        const {
            children,
            experimentGroup,
            cachedExperimentGroup,
            testName,
        } = props;
        const variantExists = React.Children.toArray(children)
            .some((child) => ((child.props.name === experimentGroup)
                || renderControlForVariant(child.props.aliases, experimentGroup)));

        if (!variantExists) {
            logger.warn(`no variant ${experimentGroup} detected for experiment ${testName}`);
        }

        this.state = {
            // render the control if tests are turned off or if no variant is declared in code
            // if we detect a cachedExperimentGroup the first render pass should render the cached experience
            experimentGroup: variantExists
                ? (cachedExperimentGroup || experimentGroup)
                : 'control',
            twoPassRender: false,
        };
    }

    componentDidMount() {
        const {
            eventData,
            onShowTest,
            experimentGroup,
            cachedExperimentGroup,
        } = this.props;

        fireSplitTestEvent(eventData);
        onShowTest();
        if (experimentGroup !== cachedExperimentGroup) {
            // if we detect a cachedExperimentGroup mismatch the second render pass should render the intended experience
            this.setState((state) => ({ ...state, experimentGroup, twoPassRender: true }));
        }
    }

    render() {
        const {
            calculateProps,
            children,
            testName,
        } = this.props;
        const {
            experimentGroup,
            twoPassRender,
        } = this.state;

        return (
            <SplitTestContext.Provider
                value={{
                    calculateProps,
                    experimentGroup,
                    testName,
                }}
            >
                {!twoPassRender && children}
                {twoPassRender && children}
            </SplitTestContext.Provider>
        );
    }
}

export default SplitTest;
